import React, { useState } from "react";
import PageHero from "../../Component/PageHero/PageHero";
import styles from "../../styles/pages/charge-wallet-type.module.scss";
import { Link, withRouter, useHistory } from "react-router-dom";
import { Button, Image, Input, message } from "antd";
import img_1 from "../../images/Group 59551.svg";
import visaImg from "../../images/visa.svg";
import codImg from "../../images/Cash_on_delivery.jpg";
import { useDispatch, useSelector } from "react-redux";
import Api from "../../Network/ApiConfig";
import cls from "classnames";
import tick from "../../images/tick.svg";
import { setUserOrder } from "../../redux/cart/cart.action";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { Modal } from "antd";
import en from "../../localization/en";
import { css } from "@emotion/css";

function PaymentMethod() {
  const t = en;
  const { order } = useSelector((state) => state?.cart);
  const { currentLang } = useSelector((state) => state?.user);
  const [loading, setLoading] = useState(false);
  const [PaymentTypeId, setPaymentTypeId] = useState(1); // 1 = Visa, 3 = COD
  const [paymentLink, setPaymentLink] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  // For popup
  const openPaymentPopup = (link) => {
    window.open(link, "_blank", "width=600,height=700");
  };

  // Payment confirm handler
  const handlePayment = async () => {
    setLoading(true);
  
    const isBusiness = order?.OrderPersonType === "business";
    const id = order?.OrderPersonId;
    let endpoint = "";
    
    try {
      if (PaymentTypeId === 1) {
        // VISA - Generate payment link and log
        const res = await Api.post("Business/GeneratePaymentLinkAndLog", {
          OrderId: order?.Id,
          Amount: order?.Total,
        });
        setLoading(false);
        if (res?.data?.model?.PaymentLink) {
          setPaymentLink(res.data.model.PaymentLink);
          setIsModalVisible(true); // Show modal
        } else {
          message.error("Could not generate payment link");
        }
      } else if (PaymentTypeId === 3) {
        // COD - Update payment status, pick correct endpoint
        if (!id) {
          message.error("Missing ID for COD.");
          setLoading(false);
          return;
        }
        if (isBusiness) {
          endpoint = `Business/UpdateBusinessOrderPayment?Id=${id}`;
        } else {
          endpoint = `Business/UpdateCustomerOrderPayment?Id=${id}`;
        }
        await Api.post(
          endpoint,
          {
            OrderId: order?.Id,
            OrderTypeId: order?.OrderTypeId || 2,
            PaymentTypeId: 3, // or 1 if your backend expects 1 for COD (double-check this!)
          }
        );
        setLoading(false);
        message.success(t.paymentSuccess);
        // dispatch(setUserOrder(null));
        history.push({
          pathname: "/order",
          state: { ordered: true },
        });
      }
    } catch (err) {
      setLoading(false);
      message.error(err?.message || "Payment failed.");
    }
  };
  
const imageSize = css`
width:5rem;`;
  return (
    <div className={styles.charge_wallet_type_page}>
      <div className="container">
        <div className={styles.charge_wallet_type_page_holder}>
          <h3 className="shared-title">
            {t.selectPayment} <span>{t.method}</span>
          </h3>
          <ul className={styles.charge_wallet_type_list}>
            <li>
              <div
                className={styles.item_content}
                onClick={() => setPaymentTypeId(1)}
                style={{ cursor: "pointer" }}
              >
                <div className={styles.item_head}>
                  <Image src={visaImg} preview={false} />
                  <p>Visa</p>
                </div>
                {PaymentTypeId === 1 && (
                  <div className={styles.image_holder}>
                    <Image src={tick} preview={false} />
                  </div>
                )}
              </div>
            </li>
            <li>
              <div
                className={styles.item_content}
                onClick={() => setPaymentTypeId(3)}
                style={{ cursor: "pointer" }}
              >
                <div  className={styles.item_head}>
                  <Image  className={imageSize} src={codImg} preview={false} />
                  <p>Cash On Delivery (Extra 10 AED)</p>
                </div>
                {PaymentTypeId === 3 && (
                  <div className={styles.image_holder}>
                    <Image src={tick} preview={false} />
                  </div>
                )}
              </div>
            </li>
          </ul>
          <Button
            type="primary"
            className={cls("btn-primary fw", styles.btn_confirm)}
            style={{ marginTop: "9rem" }}
            onClick={handlePayment}
            loading={loading}
          >
            {t.confirm}
          </Button>
        </div>
      </div>
      <Modal
      title={t.PaymentLink}
      visible={isModalVisible}
      onCancel={() => {
        setIsModalVisible(false);
        history.push("/orders");
      }}
      onOk={() => {
        setIsModalVisible(false);
        history.push("/orders");
      }}
      footer={[
        <Button
          key="copy"
          type="primary"
          onClick={() => {
            navigator.clipboard.writeText(paymentLink);
            message.success(t.copiedToClipboard || "Copied!");
          }}
        >
          {t.copyLink || "Copy Link"}
        </Button>,
        <Button
          key="ok"
          onClick={() => {
            setIsModalVisible(false);
            history.push("/paymentLogs");
          }}
        >
          {t.ok || "Done"}
        </Button>,
      ]}
    >
      <p style={{ wordBreak: "break-all" }}>{paymentLink}</p>
    </Modal>
    </div>

  )
}

export default PaymentMethod;
